import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Row, Col, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import appConfig from 'app.config'

interface IOutOfService {
	showModal: boolean
	onClick: any
	message: string | React.ReactNode
	icon: any
	color?: string
}

export const OutOfServiceModal = ({
	showModal,
	onClick,
	message,
	icon,
	color,
}: IOutOfService) => {
	const { t } = useTranslation()

	return (
		<Modal
			className={`${appConfig.country}`}
			dialogClassName="outOfService m-auto"
			show={showModal}
			animation={false}
			backdrop="static"
			centered>
			<Modal.Title className="text-center text-md mt-3">
				{message === 'Network Error' ? message : t('DataNotFound')}
			</Modal.Title>
			<Modal.Body>
				<Col className="text-center">
					{icon && (
						<FontAwesomeIcon
							icon={icon ?? 'exclamation-triangle'}
							size="6x"
							color={color}
						/>
					)}
				</Col>
				<Col className="text-center my-3">
					{message === 'Network Error' ? (
						<>
							{t('OutOfService')} <br />
							{t('OutOfServiceLoggedOut')} <br />
							{t('OutOfServiceTryAgain')}
						</>
					) : (
						<>
							{typeof message === 'string'
								? message
										.split('\n')
										.map((line: string, key: number) => (
											<div key={key}>{line}</div>
										))
								: message}
						</>
					)}
				</Col>
				<Container>
					<Row className="d-flex justify-content-center my-2">
						<Button variant="primary" onClick={onClick}>
							{t('OutOfServiceOk')}
						</Button>
					</Row>
				</Container>
			</Modal.Body>
		</Modal>
	)
}
